import React from 'react';
import PropTypes from 'prop-types';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

class AccomodationsMap extends React.Component {
    constructor(props) {
        super(props);
        this.map = null;
        this.myRef = React.createRef();
    }

    componentDidMount() {
        this.initMap();
    }

    componentDidUpdate() {
        if (this.map) {
            this.map.remove();
            this.map = null;
        }
        this.initMap();
    }

    componentWillUnmount() {
        if (this.map) this.map.remove();
    }

    initMap() {
        const { schools } = this.props;
        this.map = L.map(this.myRef.current, { scrollWheelZoom: false });

        L.tileLayer(
            'https://cache.kartverket.no/v1/wmts/1.0.0/topo/default/webmercator/{z}/{y}/{x}.png',
            {
                attribution: '&copy; <a href="https://www.kartverket.no/">Kartverket</a>',
                maxZoom: 18,
            }
        ).addTo(this.map);

        const bounds = L.latLngBounds();
        let currentPopup = null;

        schools.forEach((item) => {
            const latlng = [parseFloat(item.lat), parseFloat(item.lng)];
            const marker = L.marker(latlng).addTo(this.map);

            marker.on('click', () => {
                if (currentPopup) currentPopup.close();
                currentPopup = marker
                    .bindPopup(`<a style="color:inherit" href="#${item.slug}">${item.title}</a>`)
                    .openPopup();
            });

            bounds.extend(latlng);
        });

        this.map.fitBounds(bounds);
    }

    render() {
        return (
            <div className="map__container-wrapper">
                <div ref={this.myRef} className="map"></div>
            </div>
        );
    }
}

AccomodationsMap.propTypes = {
    schools: PropTypes.array,
};

export default AccomodationsMap;
